import { SessionManager } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getSessionManager = () => new SessionManager({ host: env.herbieApiHost });

const QUERY_KEY = 'LOGIN';
const QUERY_KEY_SSO_TOKEN = 'SSO_TOKEN';

const useGetHubSpotSSOToken = (options?: Partial<UseQueryOptions<string>>) => {
  return useQuery<string>({
    queryKey: [QUERY_KEY, QUERY_KEY_SSO_TOKEN],
    queryFn: () => getSessionManager().getHubSpotSSOToken(),
    ...options,
  });
};

export { useGetHubSpotSSOToken };
